<template>
  <div class="container">
    <main class="sub-content">
      <article class="sub" style="padding-top: 0px; padding-right: 0.5rem; padding-left: 0.5rem;">
        <section class="box-bg search-area" style="padding: 0.75rem; padding-right: 5px;">
          <div class="search_area">
            <div class="grid-container mar_0">
              <div style="line-height: 35px;">
                배송처코드:
              </div>
              <div style="grid-column: 2 / -3;">
                <DxTextBox
                  fontSize="20px"
                  height="35px"
                  v-model="dlvdId"
                  :onEnterKey="handleAtmSearch"
                />
            </div>
            <button
              class="btn btn_type_01 font13 wpAuto"
              @click="handleAtmSearch"
            >
              조회
            </button>
            <button
              class="btn btn_type_01 font13 wpAuto"
              style="background-color: #2bd3c6; color: #fff;"
              @click="handleAddAll"
            >
              추가
            </button>
            </div>
          </div>
        </section>
        <section v-if="dataList && dataList.length > 0" class="box-bg pad_5 mar_t5">
          <div class="grid-list-container" style="font-size: 20px; font-weight: bold;">
            <div class="grid-item disp-flex checkbox-div-align" style="justify-content: flex-end;">
              <input
                type="checkBox"
                :id="`allCheck`"
                :checked="allCheck"
                @click="handleAllCheckClick"
              />
              <label for="allCheck"></label>
            </div>
            <div style="grid-column: 2 / 3; line-height: 34px;">
            </div>
            <div class="disp-flex checkbox-div-align" style="grid-column: 3 / -1; justify-content: flex-start;">
              ATM 목록
            </div>
          </div>
          <div class="font20"
            style="height: calc(100vh - 110px); overflow: auto;">
            <div
            v-for="(atmInfo, atmIdx) in dataList"
            :key="`atmInfo-${atmIdx}`"
            class="border-top"
            @click.prevent="e => handleItemCheckClick(e, atmIdx)"
            >
              <div class="grid-list-container">
                <div class="grid-item disp-flex checkbox-div-align">
                  <input
                    v-if="!atmInfo.mntc_work_date"
                    type="checkBox"
                    :id="`check_${atmIdx}`"
                    :checked="checkValList[atmIdx]"
                  />
                  <label :for="`check_${atmIdx}`"></label>
                </div>
                <div class="grid-atm-name">
                  {{ atmInfo.atm_name }}
                </div>
                <div class="disp-flex checkbox-div-align imgViewBtn" name="imgViewBtn">
                  <div v-if="!atmInfo.mntc_work_date" class="grid-list-btn imgViewBtn" name="imgViewBtn">
                    추가
                  </div>
                  <div v-else class="grid-list-btn mntcDone" name="imgViewBtn">
                    수행완료
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-else class="box-bg pad_20 mar_t5">
          조회결과가 없어요.
        </section>
      </article>
    </main>
  </div>
</template>

<script>
import { EventBus } from '@/modules/event-bus'

import DxTextBox from 'devextreme-vue/text-box'

export default {
  name: 'AtmSearchModal',
  components: {
    DxTextBox
  },
  props: [ 'propDlvdId' ],
  data: () => ({
    dlvdId: '',
    allCheck: false,
    dataList: [],
    checkValList: []
  }),
  computed: {
    checkedItemList () {
      if (this.allCheck) {
        return this.dataList
          .filter(obj => !obj.mntc_work_date)
          .map(obj => {
            const { dlvd_id, com_num, atm_num } = obj
            return { dlvd_id, com_num, atm_num }
          })
      }
      const resList = []
      this.checkValList.forEach((val, idx) => {
        if (val) {
          const { dlvd_id, com_num, atm_num } = this.dataList[idx]
          resList.push({
            dlvd_id, com_num, atm_num
          })
        }
      })
      return resList
    },
    addConfirmMsg () {
      return (
        `선택하신 ATM${this.checkedItemList.length > 1 ? '들이' : '이'} 스케줄에 추가됩니다.`
      )
    },
    getUserId () {
      return window.$store.getters['Login/getUserId'].toLocaleLowerCase()
    }
  },
  created () {
    if (this.propDlvdId) {
      this.dlvdId = this.propDlvdId
      this.handleAtmSearch()
    }
  },
  mounted () {

  },
  watch: {

  },
  methods: {
    async handleAtmSearch () {
      if (!this.dlvdId) {
        return
      }
      const res = await this.$http.get(`/api/purchase/customerCare/atm/${this.dlvdId}`)

      if (res) {
        const { data: { result, status } } = res
        if (status === '200') {
          this.dataList = result.filter(obj => {
            const { mntc_psic_id, plan_psic_id } = obj
            const baseIdArray = [
              `${mntc_psic_id}`.toLocaleLowerCase(),
              `${plan_psic_id}`.toLocaleLowerCase()
            ]
            return !baseIdArray.includes(this.getUserId)
          })
          this.checkValList = this.dataList.map(_obj => false)
        }
      }
    },
    handleAddAll () {
      this.$Alert.confirm(this.addConfirmMsg)
        .then(res => {
          if (res) {
            EventBus.$emit('atmMntcSchd-atm-add', this.checkedItemList)
          }
        })
    },
    handleAllCheckClick (e) {
      const { target: { checked } } = e
      this.allCheck = checked
      this.checkValList = this.dataList.map(obj => {
        if (obj.mntc_work_date) {
          return false
        }
        return checked
      })
    },
    handleItemCheckClick (e, trgtIdx) {
      const { target: { classList } } = e
      if (classList.contains('imgViewBtn')) {
        this.$Alert.confirm(this.addConfirmMsg)
          .then(res => {
            if (res) {
              const { dlvd_id, com_num, atm_num } = this.dataList[trgtIdx]
              EventBus.$emit('atmMntcSchd-atm-add', [{ dlvd_id, com_num, atm_num }])
            }
          })
        return
      }
      if (classList.contains('mntcDone')) {
        const { mntc_work_date, mntc_psic_id } = this.dataList[trgtIdx] // atm_name
        this.$Alert.alert(`${mntc_work_date}에 ${mntc_psic_id}님에 의해 수행된 이력이 있습니다.`)
        return
      }

      this.checkValList = this.checkValList.map((val, idx) => {
        if (idx !== trgtIdx) {
          return val
        }
        return !val
      })
      const isAllcheckValList = this.checkValList.filter(val => val).length === this.dataList.length
      this.allCheck = isAllcheckValList
    }
  }
}
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 5px; /* 셀 간격 설정 */
    margin-top: 10px;
    margin-bottom: 10px;
}
.grid-list-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 5px; /* 셀 간격 설정 */
    margin-top: 10px;
    margin-bottom: 10px;
}
.grid-item {
  padding: 2px;
  text-align: center;
}
.border-top {
  border-top: 1px solid #ccc;
}
  .grid-atm-name {
    grid-column: 2 / 5;
    line-height: 34px;
  }
  .grid-list-btn {
    display: inline-block;
    padding: 10px 15px;
    background-color: #369be9; /* Button background color */
    color: #fff; /* Button text color */
    border: none;
    border-radius: 5px; /* Rounded corners */
    cursor: pointer;
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    text-decoration: none;
  }
  .disp-flex {
    display: flex;
  }
  .checkbox-div-align {
    justify-content: center;
    align-items: center;
  }
  input[type="checkbox"]{
    display: none;
  }
  input[type="checkbox"] + label{
    display: inline-block;
    width: 30px;
    height: 30px;
    border:3px solid #707070;
    position: relative;
  }
  input[type="checkbox"]:checked + label::after{
    content:'✔';
    font-size: 25px;
    width: 30px;
    height: 30px;
    text-align: center;
    position: absolute;
    left: -3px;
    top: -6px;
    color: #2bd3c6;
  }
</style>



// WEBPACK FOOTER //
// src/views/customerCare/AtmSearchModal.vue